module.exports = __webpack_public_path__ + "media/img/patchwork-icon-4a51a01c7b4ea65f7db33c70275aaf47.png";